import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../../firebase/config';

// Helper to determine FY
const getFY = (date) => {
    const d = new Date(date);
    const m = d.getMonth();
    const y = d.getFullYear();
    return m < 3 ? `${y-1}-${y}` : `${y}-${y+1}`;
};

export default function EmployeeTrainingStats({ userId, appId }) {
    const [statsByYear, setStatsByYear] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (!userId) return;
            try {
                const ref = collection(db, `artifacts/${appId}/pd_activities`);
                // Fetch only completed activities for this user
                const q = query(ref, where('userId', '==', userId), where('status', '==', 'Completed'));
                const snap = await getDocs(q);

                const yearMap = {};

                snap.forEach(doc => {
                    const data = doc.data();
                    const date = data.date ? data.date.toDate() : data.createdAt.toDate();
                    const fy = getFY(date);
                    const hours = Number(data.hours) || 0;

                    if (!yearMap[fy]) {
                        yearMap[fy] = { fy, total: 0, count: 0 };
                    }
                    yearMap[fy].total += hours;
                    yearMap[fy].count += 1;
                });

                // Convert to array and sort descending by FY
                const sorted = Object.values(yearMap).sort((a, b) => b.fy.localeCompare(a.fy));
                setStatsByYear(sorted);
            } catch (err) {
                console.error("Error loading profile stats:", err);
            }
            setLoading(false);
        };
        fetchStats();
    }, [userId, appId]);

    if (loading) return <div className="text-xs text-gray-400 animate-pulse">Loading stats...</div>;

    if (statsByYear.length === 0) {
        return (
            <div className="p-3 bg-gray-50 rounded-lg border border-gray-100 text-center">
                <p className="text-xs text-gray-400">No training data recorded.</p>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Training Summary</h4>
            <div className="border border-gray-200 rounded-lg overflow-hidden">
                <table className="min-w-full text-xs text-left">
                    <thead className="bg-gray-50 text-gray-500 font-medium">
                        <tr>
                            <th className="px-3 py-2 border-b">Financial Year</th>
                            <th className="px-3 py-2 border-b text-right">Activities</th>
                            <th className="px-3 py-2 border-b text-right">Total Hours</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 bg-white">
                        {statsByYear.map((stat) => (
                            <tr key={stat.fy}>
                                <td className="px-3 py-2 font-medium text-[#213368]">{stat.fy}</td>
                                <td className="px-3 py-2 text-right text-gray-600">{stat.count}</td>
                                <td className="px-3 py-2 text-right font-bold text-[#20BEC6]">{stat.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}